module.exports = __webpack_public_path__ + "mdkt2018/img/cnt-prize.1b7893c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/cnt-prize.png
// module id = bYss
// module chunks = 1